import { PencilSimpleLine } from '@phosphor-icons/react'
import Spinner from 'components/Spinner'
import { Table } from 'antd'
import { useGetItemsToBring } from 'api/Listings/itemsToBring'
import moment from 'moment'
import React, { useEffect, useMemo } from 'react'
import { itemsToBringStore } from 'state/listing/itemsToBringListing'
import { ItemsToBringListing } from 'types/listing/listings'

interface ItemsToBringProps {
  id: string
}

const ItemsToBring: React.FC<ItemsToBringProps> = ({ id }) => {
  const { data, isLoading, isFetching, refetch } = useGetItemsToBring()
  const { setAddItemsToBringModal, setItemsToBringData } = itemsToBringStore(
    store => ({
      setAddItemsToBringModal: store.setAddItemsToBringModal,
      setItemsToBringData: store.setItemsToBringData,
    }),
  )
  const handleEditClick = (data: ItemsToBringListing) => {
    setItemsToBringData(data)
    setAddItemsToBringModal(true)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => <p className="text-14 w-400">{text}</p>,
    },
    {
      title: 'Icon',
      dataIndex: 'icon',
      key: 'icon',
      render: (text: string) => (
        <img src={text} alt="icon" className="w-30px h-30px radius-rounded" />
      ),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (text: string) => (
        <p className="text-14 w-400">{moment(text).format('DD MMM, YYYY')}</p>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: '100px',
      render: (data: ItemsToBringListing) => (
        <div className="flex align-center gap-20px">
          <PencilSimpleLine
            size={20}
            color="#000"
            className="pointer"
            onClick={() => handleEditClick(data)}
          />
        </div>
      ),
    },
  ]

  useEffect(() => {
    refetch()
  }, [id])

  const tableData = useMemo(() => {
    return (
      data?.map((item: any) => ({
        key: item._id,
        name: item.name,
        icon: item.icon.thumb,
        updatedAt: item.updatedAt,
        actions: item,
      })) || []
    )
  }, [data])

  return (
    <div>
      {isLoading || isFetching ? (
        <div className="w-full h-70vh flex align-center justify-center">
          <Spinner />
        </div>
      ) : (
        <Table
          className="colored_header_table"
          columns={columns}
          dataSource={tableData}
          pagination={false}
        />
      )}
    </div>
  )
}

export default ItemsToBring
